module.exports = __webpack_public_path__ + "img/main_05_product_img_01@2x.2f7a1ce9.png";